export default __webpack_public_path__ + "static/8d36f984-1a3a-4618-a9de-355704b5d693-c0a7c56a9d6df4e36dc2373808ee1855.woff2";